import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    creatingExternalAccount: false,
    fetchingExternalAccounts: false,
    fetchtingExternalAccount: false,
    deleteingExternalAccount: false,
    updateAccount: false,
    fetchingProviders: false,
    providers: [],
    externalAccountResultInfo: [],
    externalAccounts: [],
    externalAccountNoCaptain: [],
    externalAccount: {},
    accountId: 0,
    selectedBucket: null,
  },
  mutations: {
    // creating account
    ADD_EXTERNAL_ACCOUNT(state, value) {
      state.creatingExternalAccount = value
    },
    CREATED_EXTERNAL_ACCOUNT(state, value) {
      state.externalAccounts.push = value
    },
    CHANGE_BUCKET_NAME(state, value) {
      state.selectedBucket = value
    },
    // fetching accounts
    FETCH_EXTERNAL_ACCOUNTS(state, value) {
      state.fetchingExternalAccounts = value
    },
    FETCH_EXTERNAL_ACCOUNT(state, value) {
      state.fetchtingExternalAccount = value
    },
    SET_EXTERNAL_ACCOUNTS(state, query) {
      const accounts = query.data?.result || []
      accounts.sort((a, b) => (b.bucketName !== null) - (a.bucketName !== null) || b.accountType - a.accountType)

      state.externalAccounts = accounts
      state.externalAccountNoCaptain = accounts.filter(item => item.parentId !== '0')
      state.externalAccountResultInfo = query.data.resultInfo

      if (!query.data.isForOrigin && !Object.keys(state.externalAccount).length && accounts.length) {
        state.externalAccount = { ...accounts[0] }
        state.accountId = accounts[0]?.id || null
      }
    },
    SET_EXTERNAL_ACCOUNT(state, data) {
      state.externalAccount = data.result
    },
    CHANGE_ACCOUNT(state, account) {
      state.externalAccount = account
    },
    // deleting external account
    DELETE_EXTERNAL_ACCOUNT(state, value) {
      state.deleteingExternalAccount = value
    },
    UPDATE_EXTERNAL_ACCOUNT(state, value) {
      state.updateAccount = value
    },
    SET_UPDATE_EXTERNAL_ACCOUNT(state, data) {
      state.externalAccount = data.result
    },
    // Providers
    FETCHING_PROVIDERS(state, value) {
      state.fetchingProviders = value
    },
    SET_PROVIDERS(state, data) {
      state.providers = data
    },
    SET_ACCOUNT_ID(state, id) {
      state.accountId = id
    },
  },
  actions: {
    // POST
    addAccount({ commit }, query) {
      commit('ADD_EXTERNAL_ACCOUNT', true)
      return new Promise((resolve, reject) => {
        api('storage')
          .post(`/v2/projects/${projectId()}/external-account`, query)
          .then(response => {
            commit('CREATED_EXTERNAL_ACCOUNT', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('ADD_EXTERNAL_ACCOUNT', false)
          })
      })
    },
    // GET
    fetchAccounts({ commit }, isForOrigin) {
      commit('FETCH_EXTERNAL_ACCOUNTS', true)
      return new Promise((resolve, reject) => {
        api('storage')
          .get(`/v2/projects/${projectId()}/external-account`)
          .then(response => {
            commit('SET_EXTERNAL_ACCOUNTS', { data: response?.data, isForOrigin })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('FETCH_EXTERNAL_ACCOUNTS', false)
          })
      })
    },
    // GET BY ID
    fetchAccount({ commit }, accountId) {
      commit('FETCH_EXTERNAL_ACCOUNT', true)
      return new Promise((resolve, reject) => {
        api('storage')
          .get(`/v2/projects/${projectId()}/external-account/${accountId}`)
          .then(response => {
            commit('SET_EXTERNAL_ACCOUNT', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('FETCH_EXTERNAL_ACCOUNT', false)
          })
      })
    },
    // Delete
    deleteAccount({ commit }, accountId) {
      commit('DELETE_EXTERNAL_ACCOUNT', true)
      return new Promise((resolve, reject) => {
        api('storage')
          .delete(`/v2/projects/${projectId()}/external-account/${accountId}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('DELETE_EXTERNAL_ACCOUNT', false)
          })
      })
    },
    // UPDATE
    updateAccount({ commit }, { id, account }) {
      commit('UPDATE_EXTERNAL_ACCOUNT', true)
      return new Promise((resolve, reject) => {
        api('storage')
          .put(
            `/v2/projects/${projectId()}/external-account/${id}`,
            account,
          )
          .then(response => {
            commit('SET_UPDATE_EXTERNAL_ACCOUNT', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('UPDATE_EXTERNAL_ACCOUNT', false)
          })
      })
    },
    // Providers
    fetchProviders({ commit }) {
      commit('FETCHING_PROVIDERS', true)

      return new Promise((resolve, reject) => {
        api('storage')
          .get(`/v2/projects/${projectId()}/providers`)
          .then(response => {
            commit('SET_PROVIDERS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('FETCHING_PROVIDERS', false)
          })
      })
    },
  },
}
